import { gcApi } from '../config/axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import DateFormatter from 'utils/date/DateFormatter';

import {
    FETCH_HEALTH_SNAPSHOT_LIST,
    FETCH_HEALTH_SNAPSHOT_LIST_START,
    FETCH_HEALTH_SNAPSHOT_LIST_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_LIST_FAIL,
    FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE,
    FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_START,
    FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_FAIL,
    FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY,
    FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_START,
    FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_SUCCESS,
    FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_FAIL,
    FETCH_HEALTH_SNAPSHOT_SUMMARY,
    FETCH_HEALTH_SNAPSHOT_SUMMARY_START,
    FETCH_HEALTH_SNAPSHOT_SUMMARY_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_SUMMARY_FAIL,
    FETCH_HEALTH_SNAPSHOT_EPOCH_DATA,
    FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_START,
    FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_FAIL,
    FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES,
    FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_START,
    FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_FAIL,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_START,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_START,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL,
    UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE,
    UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_START,
    UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_SUCCESS,
    UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_FAIL
} from 'actions/ActionTypes';

export function* fetchHealthSnapshotList(action) {
    try {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_LIST_START
        });

        const { startIndex, count } = action.payload;
        const maxDate = DateFormatter.formatISODate(new Date());

        const response = yield call(
            gcApi.get,
            `/wellnessactivity-service/activity/summary/list?limit=${count}&start=${startIndex}&until=${maxDate}`
        );

        yield put({
            type: FETCH_HEALTH_SNAPSHOT_LIST_SUCCESS,
            data: response.data || [],
            startIndex
        });
    } catch (e) {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_LIST_FAIL
        });
    }
}

export function* fetchHealthSnapshotListByDateRange(action) {
    try {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_START
        });

        const { fromDate, untilDate } = action.payload;

        const response = yield call(
            gcApi.get,
            `/wellnessactivity-service/activity/summary/range/${fromDate}/${untilDate}`
        );

        yield put({
            type: FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_SUCCESS,
            data: response.data || []
        });
    } catch (e) {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_FAIL
        });
    }
}

export function* fetchHealthSnapshotsForDailySummary(action) {
    try {
        yield put({
            type: FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_START
        });

        const calendarDate = action.payload;

        const response = yield call(gcApi.get, `/wellnessactivity-service/activity/summary/${calendarDate}`);

        yield put({
            type: FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_SUCCESS,
            data: response.data || [],
            calendarDate: calendarDate
        });
    } catch (e) {
        yield put({
            type: FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_FAIL
        });
    }
}

export function* fetchHealthSnapshotSummary(action) {
    try {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_SUMMARY_START
        });

        const { calendarDate, snapshotId } = action.payload;
        const response = yield call(
            gcApi.get,
            `/wellnessactivity-service/activity/summary/${calendarDate}/${snapshotId}`
        );

        yield put({
            type: FETCH_HEALTH_SNAPSHOT_SUMMARY_SUCCESS,
            data: response.data || {}
        });

        if (response.data) {
            const { startTimestampLocal, activityUuid } = response.data;
            yield call(fetchHealthSnapshotRelativeActivities, {
                payload: {
                    startTimestamp: startTimestampLocal,
                    activityUuid: activityUuid.uuid
                }
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_SUMMARY_FAIL,
            data: e.response && e.response.data
        });
    }
}

export function* fetchHealthSnapshotEpochData(action) {
    try {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_START
        });

        const { snapshotId } = action.payload;
        const response = yield call(gcApi.get, `/wellnessactivity-service/activity/epoch/${snapshotId}`);

        yield put({
            type: FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_SUCCESS,
            data: response.data || {}
        });
    } catch (e) {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_FAIL
        });
    }
}

export function* fetchHealthSnapshotRelativeActivities(action) {
    try {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_START
        });

        const { startTimestamp, activityUuid } = action.payload;
        const response = yield call(gcApi.get, `/wellnessactivity-service/activity/relative/${startTimestamp}`);

        yield put({
            type: FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_SUCCESS,
            data: response.data || [],
            payload: { activityUuid }
        });
    } catch (e) {
        yield put({
            type: FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_FAIL
        });
    }
}

export function* deleteHealthSnapshotListItem(action) {
    try {
        yield put({
            type: DELETE_HEALTH_SNAPSHOT_LIST_ITEM_START,
            payload: action.payload
        });

        const { activityUuid, calendarDate } = action.payload;

        const response = yield call(gcApi.delete, `/wellnessactivity-service/activity/${calendarDate}/${activityUuid}`);

        yield put({
            type: DELETE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS,
            payload: activityUuid
        });
    } catch (e) {
        yield put({
            type: DELETE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL
        });
    }
}

export function* updateHealthSnapshotListItem(action) {
    try {
        yield put({
            type: UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_START,
            payload: action.payload
        });

        const { activityUuid, activityName, calendarDate } = action.payload;

        const response = yield call(
            gcApi.patch,
            `/wellnessactivity-service/activity/${calendarDate}/${activityUuid}/name`,
            { name: activityName }
        );

        yield put({
            type: UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS,
            payload: { activityUuid, activityName }
        });
    } catch (e) {
        yield put({
            type: UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL
        });
    }
}

export function* updateHealthSnapshotItemNote(action) {
    try {
        yield put({
            type: UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_START,
            payload: action.payload
        });

        const { activityUuid, activityNote, calendarDate } = action.payload;

        const response = yield call(
            gcApi.patch,
            `/wellnessactivity-service/activity/${calendarDate}/${activityUuid}/notes`,
            { notes: activityNote }
        );

        yield put({
            type: UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_SUCCESS,
            payload: { activityUuid, activityNote }
        });
    } catch (e) {
        yield put({
            type: UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_FAIL
        });
    }
}

export const healthSnapshotSagas = [
    takeEvery(FETCH_HEALTH_SNAPSHOT_LIST, fetchHealthSnapshotList),
    takeEvery(FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE, fetchHealthSnapshotListByDateRange),
    takeEvery(FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY, fetchHealthSnapshotsForDailySummary),
    takeEvery(FETCH_HEALTH_SNAPSHOT_SUMMARY, fetchHealthSnapshotSummary),
    takeEvery(FETCH_HEALTH_SNAPSHOT_EPOCH_DATA, fetchHealthSnapshotEpochData),
    takeEvery(FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES, fetchHealthSnapshotRelativeActivities),
    takeEvery(UPDATE_HEALTH_SNAPSHOT_LIST_ITEM, updateHealthSnapshotListItem),
    takeEvery(DELETE_HEALTH_SNAPSHOT_LIST_ITEM, deleteHealthSnapshotListItem),
    takeEvery(UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE, updateHealthSnapshotItemNote)
];
